<template>
  <ModalControl
    @closed="$emit('closed')"
    :show="show"
    v-bind:title="lang('lbl_0000301')"
    dismiss
  >
    <div class="text-sm text-justify p-2">
      <div class="flex flex-col pb-6 font-bold text-center text-primary">
        <span>TERMS AND CONDITIONS AGREEMENT</span>
        <span>PAFCPIC DIGITAL PRODUCTS</span>
      </div>
      <div class="pb-4">
        This <b>Terms and Conditions Agreement</b> (“Agreement”) is entered into
        by and between the
        <b
          >Philippine Army Finance Center Producers Integrated Cooperative
          (PAFCPIC)</b
        >, a duly registered cooperative organized and existing under the laws
        of the Republic of the Philippines, with principal office at Col. Efren
        Zaide Bldg., Bayani Rd., Fort Bonifacio, Taguig City (“PAFCPIC”), and
        the undersigned member (“Member”), collectively referred to as the
        “Parties.”
      </div>

      <div class="font-bold pb-2 border-b mb-4">1. GENERAL USAGE</div>
      <div class="pb-2">
        1.1 The Member shall use PAFCPIC's digital products and services
        exclusively for legitimate cooperative transactions.
      </div>
      <div class="pb-2">
        1.2 The Member shall use PAFCPIC's digital products and services
        exclusively for legitimate cooperative transactions.
      </div>
      <div class="pb-2">
        1.3 PAFCPIC reserves the right to suspend or terminate access in the
        event of any suspected misuse or breach of this Agreement.
      </div>
      <div class="pb-6">
        1.4 The Member shall direct all concerns or feedback regarding services
        to PAFCPIC's Customer Relations unit, which shall act promptly and
        fairly.
      </div>

      <div class="font-bold pb-2 border-b mb-4">
        2. TRANSACTION VALIDATION AND LIABILITY
      </div>
      <div class="pb-2">
        2.1 All transactions initiated by the Member are subject to validation
        and approval processes of PAFCPIC.
      </div>
      <div class="pb-2">
        2.2 PAFCPIC shall not be liable for losses, delays, or failures in
        transactions caused by force majeure events or independent third-party
        service failures, provided that PAFCPIC exercised due diligence.
      </div>
      <div class="pb-2">
        2.3 PAFCPIC shall remain responsible for errors, delays, or failures
        arising from its own negligence or internal system failures.
      </div>
      <div class="pb-6">
        2.4 PAFCPIC may amend this Agreement, subject to providing the Member
        with at least thirty (30) calendar days' notice prior to effectivity.
        Such notice may be sent through official channels, including email to
        the Member's registered address or an announcement on PAFCPIC's official
        website or mobile application.
      </div>

      <div class="font-bold pb-2 border-b mb-4">
        3. DATA PRIVACY AND PROCESSING OF PERSONAL INFORMATION
      </div>
      <div class="pb-2">
        3.1 The Member consents to the collection, storage, processing, and
        retention of personal and financial data for purposes of cooperative
        transactions and services.
      </div>
      <div class="pb-2">
        3.2 The Member consents to the sharing of personal data with partner
        institutions (e.g., banks) solely for Electronic Fund Transfers (EFT),
        eCollect, and related services.
      </div>
      <div class="pb-2">
        3.3 PAFCPIC shall implement appropriate safeguards against unauthorized
        access, disclosure, alteration, or misuse of Member data.
      </div>
      <div class="pb-2">
        3.4 The Member acknowledges and retains all rights under the Data
        Privacy Act of 2012, including access, correction, withdrawal, deletion,
        and indemnification.
      </div>
      <div class="pb-6">
        3.5 The Member may exercise such rights by contacting the PAFCPIC Data
        Protection Officer (DPO) through the channels provided in the Privacy
        Policy (PAFCPIC Privacy Policy
        <a
          class="text-primary underline"
          href="https://pafcpic.ph/privacy-policy"
          >https://pafcpic.ph/privacy-policy</a
        >)
      </div>

      <div class="font-bold pb-2 border-b mb-4">
        4. OPENING OF BANK ACCOUNTS (BULK ACCOUNT OPENING SYSTEM)
      </div>
      <div class="pb-2">
        4.1 Bank accounts opened through PAFCPIC's Bulk Account Opening System
        (BAOS) shall be automatically enrolled in PAFCPIC's database.
      </div>
      <div class="pb-6">
        4.2 Bank accounts opened by PNB through booths during the General
        Assembly and Patronage Refund Distribution Weeks shall likewise be
        automatically enrolled in PAFCPIC's Database. Relevant account
        information shall be received from PNB partner branches.
      </div>
      <div class="pb-6">
        4.3 Said accounts may be used for EFT, eCollect, and other
        cooperative-related transactions.
      </div>

      <div class="font-bold pb-2 border-b mb-4">
        5. ELECTRONIC FUND TRANSFER (EFT)
      </div>
      <div class="pb-2">
        5.1 The Member authorizes PAFCPIC to credit patronage refunds to the
        bank account indicated herein.
      </div>
      <!-- <div class="pb-2">
          <b>For Dividends:</b><br />
          Bank: _________ Account No.:_________
        </div> -->
      <div class="pb-2">
        <b>For Patronage Refund:</b><br />
        Bank: _________ Account No.:_________
      </div>
      <div class="pb-2">
        5.2 Mandatory deductions, including Regular Savings Deposit (RSD)  Maintaining Balance (Php 200), We Care Program (Php 50 monthly if not collected through remittance), share capital contributions (if not yet completed), and other outstanding payables (if applicable), shall be applied before crediting.
      </div>
      <div class="pb-2">
        5.3 The Member warrants the accuracy and completeness of all bank account details provided.
      </div>
      <div class="pb-2">
        5.4 PAFCPIC shall not be held liable for losses or delays arising from incorrect or incomplete bank account information.
      </div>
      <div class="pb-2">
        5.5 The Member's application for EFT (PatRef) shall remain valid and effective for all applicable tranches, unless formally revoked. Requests to change or discontinue enrollment shall be made only through the prescribed PAFCPIC forms: a new Terms and Conditions Form for changes, or a duly accomplished Cancellation Form for discontinuance.
      </div>
      <div class="pb-2">
        5.6 Applications for EFT (PatRef) are subject to specific deadlines based on the tranche*.
      </div>
      <div class="pb-2">
        Patronage Refund applications submitted:
      </div>
      <div class="pb-2">
        Dividend applications submitted on or before December 31 of the current
        year shall take effect on the following year. Patronage Refund
        applications submitted:
      </div>
      <div class="pb-2">
        <span class="font-semibold">EFFECTIVITY</span><br />
        on or before March 31 - 1st Tranche (e.g., May)<br />
        on or before June 30 - 2nd Tranche (e.g., August)<br />
        on or before September 30 - 3rd Tranche (e.g., November)
      </div>
      <div class="pb-6 italic">
        *Tranches refer to the designated month of distribution of proceeds. The schedule may be subject to change as necessary.
      </div>
      <div class="pb-6">
        5.7 Applications submitted after the applicable cut-off shall be eligible for the next tranche.
      </div>

      <div class="font-bold pb-2 border-b mb-4">
        6. eCOLLECT (Deposits to PAFCPIC Account via PNB Channels)
      </div>
      <div class="pb-2">
        6.1 Deposits received before the 2:30 PM daily cut-off shall be processed on the same day provided that it has reflected in PAFCPIC's PNB account; deposits made thereafter, on weekends, non-banking days, or holidays, shall be processed on the next working day.
      </div>
      <div class="pb-2">
        6.2 Posting of deposits shall be based on the date processed by PAFCPIC.
      </div>
      <div class="pb-6">
        6.3 Check and online deposits may require two (2) to three (3) banking days to clear. Members are responsible for making deposits on time to avoid delays in their transactions.
      </div>
      <div class="pb-6">
        6.4 Deposits made where the deposit type is unspecified or invalid shall, by default, be credited to the member's Regular Savings Deposit (RSD) account.
      </div>
      <div class="pb-6">
        6.5 In the event of any deposit-related issues, the member shall contact the PAFCPIC Customer Relations Section (CRS) at 0998-588-1969 from Mon - Fri, 9AM-4PM. The deposit subject to the reported issue shall remain pending and shall not be posted or credited until such issue has been resolved. Once resolved, the posting or crediting date shall be the date of resolution of the deposit issue.
      </div>

      <div class="font-bold pb-2 border-b mb-4">
        7. CERTIFICATION AND CONSENT
      </div>
      <div class="pb-2">
        7.1 The Member certifies that all information provided is true and correct.
      </div>
      <div class="pb-6">
        7.2 The Member authorizes PAFCPIC to:<br />
        - Update member records;<br />
        - Process personal information for legitimate cooperative purposes;
        and<br />
        - Retain data only as necessary, in accordance with the Data Privacy Act
        of 2012 and the PAFCPIC Privacy Policy.
      </div>

      <div class="font-bold pb-2 border-b mb-4">8. GOVERNING LAW</div>
      <div class="pb-6">
        This Agreement shall be governed by the pertinent laws and related rules issued by the government and its regulatory agencies.
      </div>

      <div class="font-bold pb-2 border-b mb-4">9. ACKNOWLEDGMENT</div>
      <div class="pb-4">
        By signing below, the Member affirms that he/she has read, understood, and agrees to be bound by this Agreement.
      </div>
    </div>

    <div v-if="show_agree" class="flex flex-col">
      <ButtonControl @click="agree">
        {{ lang("lbl_0000302") }}
      </ButtonControl>
    </div>
  </ModalControl>
</template>

<script>
import ModalControl from "./ModalControl.vue";
import ButtonControl from "./ButtonControl.vue";
import mixin from "./../../mixin.js";

export default {
  name: "v-eft-terms-control",
  mixins: [mixin],
  components: {
    ModalControl,
    ButtonControl,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    show_agree: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    agree() {
      this.$emit("agreed");
    },
  },
};
</script>
